<main id="main" class="list-height article-listing-main">

    <section id="" class="pt-0" aria-label="about">

        <div class="container article-listing-container">
            <div class="d-flex  pt-3 pb-3 article-breadcrumb">
                <span class="article-breadcrumb-sec" *ngIf="breadcrumb">
                    <span class="breadcrumb-nav" role="button" tabindex="0" (click)="goToPage('')"
                        (keyup.enter)="goToPage('')" (keyup.space)="goToPage('')"
                        aria-label="Go to Journal of the British Academy" title="Journal of the British Academy">
                        <i><span class="nav-string nav-string-home"> Journal of the British Academy</span></i>
                        <fa-icon aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']">
                        </fa-icon>
                    </span>
                    <span *ngIf="showTab === 'current-articles'" (click)="goToPage('current-articles')"
                        class="breadcrumb-nav nav-string">{{'article_listing.current_articles_jba'| translate}}</span>
                    <span *ngIf="showTab === 'all-articles'">{{'article_listing.all_article'| translate}}</span>
                    <fa-icon *ngIf="showTab === 'current-articles'" aria-hidden="true" class="angle-icon"
                        [icon]="['fas', 'angle-right']">
                    </fa-icon>
                    <span *ngIf="thematicOnly" (click)="goToPage('thematic-collections')"
                        class="breadcrumb-nav nav-string">{{'app_header.special_issues_jba'| translate}}</span>
                    <fa-icon *ngIf="thematicOnly && volume_id" aria-hidden="true" class="angle-icon"
                        [icon]="['fas', 'angle-right']">
                    </fa-icon>
                    <span *ngIf="thematicOnly && volume_id" (click)="goToPage('thematic-collections/' + volume_id)"
                        class="breadcrumb-nav nav-string"> Volume {{volume_id}}</span>
                    <fa-icon *ngIf="articleList[0] && articleList[0]['thematic_collection'] && thematicOnly"
                        aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']">
                    </fa-icon>
                    <ng-container *ngIf="thematicOnly">
                        <span
                            *ngIf="articleList[0] && articleList[0]['thematic_collection']">{{articleList[0]['thematic_collection']}}</span>
                    </ng-container>
                    <ng-container *ngIf="!thematicOnly">
                        <span *ngIf="volume_id" (click)="goToPage('volumes')" class="breadcrumb-nav">
                            <span class="nav-string"> Volume {{volume_id}}</span>
                            <fa-icon aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']">
                            </fa-icon>
                        </span>

                        <!-- <span *ngIf="issue_id !== 'non-issue' && !shoWListOFIssues">
                            {{changeIssue(issue_id)}}
                        </span> -->
                        <span *ngIf="issue_id === 'non-issue'">
                            Regular articles
                        </span>
                    </ng-container>
                    <!-- <span *ngFor="let navigationContent of breadCrumbNavigation;let lastItem = last"><a
                            [routerLink]='navigationContent.url'>{{changeIssue(navigationContent.identifier)}}</a>
                        <fa-icon *ngIf="!lastItem" aria-hidden="true" class="p-2" [icon]="['fas', 'angle-right']">
                        </fa-icon>
                    </span> -->
                </span>
            </div>
            <!-- <div class="d-flex" *ngIf="shoWListOFIssues && listOfIssues.length>0">
                <a *ngFor="let list of listOfIssues;  let i = index"
                    [routerLink]="[list]"
                    [ngClass]="(issue_id ? issue_id === list : i === 0) ? 'bold-issues' : ''">
                    {{ changeIssue(list) }} &nbsp;&nbsp;
                </a>
            </div> -->
            <ng-container *ngIf="!thematicOnly">
                <div class="d-flex" *ngIf="shoWListOFIssues && listOfIssues.length > 0">

                    <a *ngFor="let list of listOfIssues; let i = index" [routerLink]="supplementary 
                      ? ['/supplementary-collections/articles', volume_id, list.issue, 'page','1'] 
                      : ['/articles', volume_id, list.issue, 'page','1']"
                        [ngClass]="(issue_id ? issue_id === list.issue : i === 0) ? 'bold-issues' : ''">

                        {{ changeIssue(list.issue) }} &nbsp;&nbsp;

                    </a>

                </div>
            </ng-container>

            <div class="row mb-4" *ngIf="special_issue===true">
                <!-- <div class="volume-head-title d-flex justify-content-center" data-aos="fade-up" *ngIf="loading">
                    <h1 class="content-loader w-50">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h1>
                </div> -->
                <div class="volume-head-title" data-aos="fade-up">
                    <!-- <h1 tabindex="0" *ngIf="special_issue==false">{{'article_listing.current_articles_jba' | translate }}</h1> -->
                    <h1 tabindex="0">{{'article_listing.special_issues_jba' | translate }}
                    </h1>
                    <!-- <span *ngIf="volume_id && issue_id">Volume - {{volume_id}}, Issue - {{changeIssue(issue_id)}}</span> -->
                </div>
            </div>
            <!-- ======= Search Article Section start ======= -->

            <div class="card pb-4 pt-4 search-card" *ngIf="showSearchCard">
                <!--article-search component -->
                <app-article-search (searchEmit)="searchEmitFunction($event)"
                    (searchClick)="showSearchedArticle($event)" [journalid]="journalId"
                    (clearSearchClick)="clearSearch($event)" [searchLoader]="searchLoader" [selectDiv]="selectDiv"
                    (journalEmit)="journalEmit($event)" [valueSearched]="valueForSearch"></app-article-search>
                <!--article-search component -->

                <!-- artcile-search-list component -->
                <app-article-search-list [searchedArticles]="searchedArticles" [tempSearchArticles]="tempSearchArticles"
                    [journalid]="journalId" [valueForSearch]="valueForSearch" [loading]="searchLoader"
                    [show_search_list]="show_search_list"></app-article-search-list>
                <!-- artcile-search-list component -->

                <!-- <div class="row filter-section mt-1"> -->
                <!-- check box -->
                <app-article-filters [journalId]="journal_id" (emitCheck)="checkBoxChange($event)"
                    (clear_emit)="clearAllCheckbox($event)" [journal_id]="journal_id"
                    [subject_area_filter]="subject_area_filter" (volumeEmit)="emitedVolume($event)"
                    (issueEmit)="emitedIssue($event)" [volume]="volume_id" [issue]="issue_id" [uncheck]="uncheck"
                    [volumeIssue]="volumeIssue">
                </app-article-filters>
                <!-- check box ends-->
                <!-- </div> -->
            </div>
        </div>

        <div class="container mb-1 mt-1 starting-div article-listing-container">
            <div class="row">
                <!-- <div class="" *ngIf="searchPipe">
                    <div class="row">
                        <span class="pl-4 pb-3">
                            <h4>
                                Result of your search for <span style="font-weight: bold;">{{searchPipe}}</span>
                            </h4>
                        </span>
                    </div>
                </div> -->
                <!-- <div class="container mb-1 mt-1 starting-div">
                    <ul class="nav nav-tabs" id="myTabs"  role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'regular-articles'"
                                (click)="switchTab('regular-articles')" 
                                id="regular-articles-tab">{{'article_listing.current_issue' | translate}}</a>
                        </li>
                        <li class="nav-item"  *ngIf="fasttrackNav" >
                            <a class="nav-link" [class.active]="activeTab === 'fast-track-articles'"
                                (click)="switchTab('fast-track-articles')"
                                id="fast-track-articles-tab">{{'article_listing.fasttrack_article'| translate}}</a>

                        </li>
                    </ul>
                </div> -->

                <!-- <div class="container mb-1 mt-1 starting-div">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [class.active]="activeTab === 'regular-articles'"
                                (click)="switchTab('regular-articles')" 
                                id="regular-articles-tab" aria-controls="regular-articles-content" aria-selected="true" role="tab">{{'article_listing.current_issue' | translate}}</a>
                        </li>
                        <li class="nav-item" *ngIf="fasttrackNav" role="presentation">
                            <a class="nav-link" [class.active]="activeTab === 'fast-track-articles'"
                                (click)="switchTab('fast-track-articles')"
                                id="fast-track-articles-tab" aria-controls="fast-track-articles-content" aria-selected="false" role="tab">{{'article_listing.fasttrack_article'| translate}}</a>
                        </li>
                    </ul>
                </div> -->

                <!-- new code for favourite and current articles -->
                <div class="container mb-1 mt-1 starting-div" *ngIf="noNeededForJBA">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" *ngIf="showTab === 'current-articles'"
                                [class.active]="activeTab === 'current-articles'"
                                (click)="switchTab('current-articles')"
                                title="{{'article_listing.current_articles_jba'| translate}}" id="current-articles-tab"
                                aria-controls="current-articles-content" aria-selected="false"
                                role="tab">{{'article_listing.current_articles_jba'| translate}}</a>
                            <a class="nav-link" *ngIf="showTab === 'all-articles'"
                                [class.active]="activeTab === 'all-articles'" (click)="switchTab('all-articles')"
                                title="{{'article_listing.all_article'| translate}}" id="all-articles-tab"
                                aria-controls="all-articles-content" aria-selected="false"
                                role="tab">{{'article_listing.all_article'| translate}}</a>
                            <a class="nav-link" *ngIf="showTab === 'current-issue'"
                                [class.active]="activeTab === 'current-issue'" (click)="switchTab('current-issue')"
                                title="{{'article_listing.current_issue'| translate}}" id="current-issue-tab"
                                aria-controls="current-issue-content" aria-selected="false"
                                role="tab">{{'article_listing.current_issue'| translate}}</a>
                        </li>
                        <!-- <li class="nav-item" role="presentation">
                            <a class="nav-link" [class.active]="activeTab === 'regular-articles'"
                                (click)="switchTab('regular-articles')" 
                                id="regular-articles-tab" aria-controls="regular-articles-content" aria-selected="true" role="tab">{{'article_listing.current_issue' | translate}}</a>
                        </li> -->
                        <li class="nav-item" role="presentation" *ngIf="favourite_active">
                            <a class="nav-link" [class.active]="activeTab === 'favourite-articles'"
                                (click)="switchTab('favourite-articles')"
                                title="{{'article_listing.favourite_article' | translate}}" id="favourite-articles-tab"
                                aria-controls="favourite-articles-content" aria-selected="false"
                                role="tab">{{'article_listing.favourite_article' | translate}}</a>
                        </li>
                    </ul>
                </div>



                <div class="container">
                    <div class="tab-content" id="myTabsContent">
                        <!-- <div  id="regular-articles-content" class="tab-pane fade" [class.show.active]="activeTab === 'regular-articles'"
                             role="tabpanel"  aria-labelledby="regular-articles">
                            <div class="row mt-2" *ngIf="activeTab ==='regular-articles'">
                                <div class="col-lg-7 col-md-9 col-sm-12 col-12">
                                    <app-article-keyword-filter (special_issue_emit)="specialIssueChange($event)"
                                        [special_issue]="special_issue" (sort_criteria_emit)="toggleSort($event)"
                                        (keyword_show)="showKeywordDiv($event)"
                                        [journal_id]="journal_id"></app-article-keyword-filter>
                                </div>
                                <div class="col-lg-5 col-md-3 col-sm-12 col-12"><app-article-pagination [articleList]="articleList"
                                        [journal_id]="journal_id" [currentPage]="currentPage" [queryPara]="queryPara"
                                        [totalPages]="totalPages"
                                        [regularPagination]="regularPagination">
                                    </app-article-pagination>
                                </div>
                                <app-article-keyword-list (keyword_selected)="clickOnEachKeywords($event)"
                                    [showkeywords]="showkeywords" [objectKeywords]="objectKeywords"
                                    [journal_id]="journal_id">
                                </app-article-keyword-list>
                                <app-article-list [articleList]="articleList" [journalid]="journal_id"
                                    [isCollapsed]="isCollapsed" [searchPipe]="searchPipe">
                                </app-article-list>
                            </div>
                        </div> -->

                        <!-- Fast Track Articles tab -->
                        <div id="current-articles" role="tabpanel" aria-labelledby="current-articles">
                            <div class="row">
                                <div class="col-sm-12 col-md-10 col-lg-10">
                                    <span *ngIf="searchPipe" class="pl-4 pb-3">
                                        <h4>
                                            Result of your search for <span
                                                style="font-weight: bold;">{{searchPipe}}</span>
                                        </h4>
                                    </span>
                                    <span *ngIf="thematicOnly && thematic_id">
                                        <p class="thematic_collection pt-3"
                                            *ngIf="articleList[0] && articleList[0]['thematic_collection']">
                                            {{articleList[0]['thematic_collection']}}</p>
                                        <p class="headingContentData"
                                            *ngIf="articleList[0] && articleList[0]['thematic_collection_edited_by']">
                                            {{articleList[0]['thematic_collection_edited_by']}}</p>
                                    </span>
                                    <!-- <div class="pt-3 ml-3"> -->
                                    <!-- </div> -->
                                    <!-- keyword filter starts -->
                                    <!-- <app-article-keyword-filter *ngIf="articleList.length > 0" (special_issue_emit)="specialIssueChange($event)"
                                        [special_issue]="special_issue" (sort_criteria_emit)="toggleSort($event)"
                                        (keyword_show)="showKeywordDiv($event)"
                                        [journal_id]="journal_id"></app-article-keyword-filter> -->
                                    <!-- keyword filter ends -->
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <!-- pagination section for Fast Track Articles -->
                                    <app-article-pagination [articleList]="articleList" [journal_id]="journal_id"
                                        [currentPage]="currentPage" [queryPara]="queryPara" [totalPages]="totalPages"
                                        (loading)="changeLoading($event)">
                                    </app-article-pagination>
                                </div>
                                <!-- article keyword list starts -->
                                <app-article-keyword-list (keyword_selected)="clickOnEachKeywords($event)"
                                    [showkeywords]="showkeywords" [objectKeywords]="objectKeywords"
                                    [journal_id]="journal_id">
                                </app-article-keyword-list>
                                <!-- article keyword list ends -->
                                <!-- article listing section for Regular Articles -->

                                <app-article-list [articleList]="articleList" [journalid]="journal_id"
                                    [isCollapsed]="isCollapsed" [searchPipe]="searchPipe" [currentPage]="currentPage"
                                    [loading]="loading">
                                </app-article-list>


                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-10 col-lg-10"></div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <!-- <div class="pagination"> -->
                                    <app-article-pagination [articleList]="articleList" [journal_id]="journal_id"
                                        [currentPage]="currentPage" [queryPara]="queryPara" [totalPages]="totalPages"
                                        (loading)="changeLoading($event)">
                                    </app-article-pagination>
                                    <!-- </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </section>
</main>